import { get } from './translations/intl.js';

export function temperatureState(reading0, application_settings, temperatureKey = '128', temperatureMax = 85) {
  const key = typeof temperatureKey === 'string' ? temperatureKey : '128';
  const currentTime = Date.now();
  const temperatureDate = new Date(reading0[key + 'Date'] || reading0['date']).getTime();

  if (!temperatureDate || temperatureDate < currentTime - 1000 * 60 * 60 * 2) {
    return 'temperatureOldReading';
  }

  const temp = reading0[key];
  let tempStart = 0;
  if (application_settings?.settings?.tempStart) {
    tempStart = application_settings.settings.tempStart;
  }
  let tempStop = 0;
  if (application_settings?.settings?.tempStop) {
    tempStop = application_settings.settings.tempStop;
  }

  if (temp && (temp === 327.67 || temp <= -40 || temp >= temperatureMax)) {
    return 'temperatureBadReading';
  }
  if (tempStart > tempStop) {
    return 'temperatureBadSetPoints';
  }
  if (temp < tempStart) {
    return 'temperatureBelowStart';
  }
  if (temp >= tempStart && temp <= tempStop) {
    return 'temperatureBetweenStartAndStop';
  }
  if (temp > tempStop) {
    return 'temperatureAboveStop';
  }
  return 'temperatureBadReading';
}

export function statusTemperature(status, device, language) {
  const reading0 = device.reading0 || {};
  const setPoints = device.physical?.temperatureSetPoints === true;

  const tempState128_0 = temperatureState(reading0, device.application_settings);

  switch (tempState128_0) {
    case 'temperatureOldReading':
    case 'temperatureBadReading':
      status.other.push({
        id: 'temperatureBadReading',
        rank: 20,
        code: 'deviceProblem',
        category: 'temperature',
        shortMessage: 'Temperature Sensor Error',
        message: `Temperature Device ${device.physical.deviceNumber} has a bad temperature reading`,
      });
      status.deviceHeadlineDanger.enabled = true;
      status.deviceHeadlineDanger.text.push(
        get(language, 'headline.temperatureProbeFault', 'Temperature Probe Fault'),
      );
      break;

    case 'temperatureBadSetPoints':
      status.other.push({
        id: 'temperatureBadSetPoints',
        rank: setPoints ? 20 : 100,
        code: setPoints ? 'deviceProblem' : 'normal',
        category: 'temperature',
        shortMessage: 'Bad set points',
        message: `Temperature Device ${device.physical.deviceNumber} has bad start and stop points`,
      });
      break;

    case 'temperatureBelowStart':
      status.other.push({
        id: 'temperatureBelowStart',
        rank: setPoints ? 20 : 100,
        code: setPoints ? 'deviceProblem' : 'normal',
        category: 'protection',
        shortMessage: 'Temperature below start set point',
        message: `Temperature Device ${device.physical.deviceNumber} is below start set point.`,
      });
      if (setPoints) {
        status.deviceHeadlineDanger.enabled = true;
        status.deviceHeadlineDanger.text.push(
          get(language, 'headline.temperatureBelowStart', 'Ambient temperature is below start temperature'),
        );
      }
      break;

    case 'temperatureBetweenStartAndStop':
      status.other.push({
        id: 'temperatureBetweenSetPoints',
        rank: setPoints ? 20 : 100,
        code: 'normal',
        category: 'protection',
        shortMessage: 'Temperature between set points',
        message: `Temperature Device ${device.physical.deviceNumber} is between set points.`,
      });
      break;

    case 'temperatureAboveStop':
      status.other.push({
        id: 'temperatureAboveStop',
        rank: setPoints ? 50 : 100,
        code: 'normal',
        category: 'protection',
        shortMessage: 'Temperature above stop point',
        message: `Temperature Device ${device.physical.deviceNumber} is above stop point.`,
      });
      break;

    default:
      break;
  }

  const inputPower = reading0['186'] & 0x4;
  if (inputPower) {
    status.other.push({
      id: 'temperatureDevicePowerOn',
      rank: 100,
      code: 'normal',
      category: 'electricity',
      shortMessage: 'Temperature Device has power',
      message: `Temperature Device ${device.physical.deviceNumber} has power.`,
    });
  } else {
    status.other.push({
      id: 'temperatureDevicePowerOff',
      rank: 15,
      code: 'disconnected',
      category: 'controller',
      shortMessage: 'Temperature Device does not have power',
      message: `Temperature Device ${device.physical.deviceNumber} does not have power.`,
    });
    status.deviceHeadlineDanger.enabled = true;
    status.deviceHeadlineDanger.text.push(
      get(language, 'headline.altracNotReceivingPower', 'Altrac is not receiving power'),
    );
    return false;
  }
}
